var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 66,
    viewBox: "0 0 65 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 68451"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1002",
    cx: 32.5,
    cy: 32.8298,
    r: 32.5,
    fill: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-Communication"
  }, /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8325 30.904C26.0794 35.3978 29.9312 39.0892 34.4251 41.4966L37.9559 37.9657C38.4374 37.4843 39.0794 37.3238 39.5609 37.6448C41.3263 38.2867 43.2522 38.6077 45.3386 38.6077C46.3016 38.6077 46.9436 39.2497 46.9436 40.2127V45.6695C46.9436 46.6324 46.3016 47.2744 45.3386 47.2744C30.2522 47.2744 18.0547 35.0769 18.0547 19.9904C18.0547 19.0275 18.6967 18.3855 19.6596 18.3855H25.2769C26.2399 18.3855 26.8818 19.0275 26.8818 19.9904C26.8818 21.9164 27.2028 23.8423 27.8448 25.7682C28.0053 26.2497 27.8448 26.8917 27.5238 27.3732L23.8325 30.904Z",
    fill: "white"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.05b60b9ed902cb0cf24cd855c7ce8688.svg";
export { ForwardRef as ReactComponent };